<template>
  <Dialog :dialogTitle="'找回签约密码'" :visible="show" :width="'400px'" @closeDialog="closeDialog">
    <div slot="dialog" class="tipContent">
      <div class="tipBox">
        <div>您还没有设置签约密码，</div>
        <div>请先设置签约密码后在进行签署！</div>
      </div>
      <div class="authHandlerBox">
        <div class="button buttonActive cursorPointer" @click="closeDialog">取消</div>
        <div class="button cursorPointer buttonActive" @click="goSetSignPwd">确定</div>
      </div>
    </div>
  </Dialog>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import Reg from "@lib/reg.js";
import BaseApi from "@lib/baseApi.js";
import md5Util from "@lib/encryption.js";
export default {
  data() {
    return {
      show: false
    };
  },
  components: {
    Dialog
  },
  created() {
    BaseApi.createRpcToken("/user/getSecurityInfo").then(
      data => {
        if (data.datas.info.existSginPwd == 1) {
          this.show = true;
        } else {
          this.show = false;
        }
      },
      data => {
        console.log(data);
      }
    );
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.show = false;
    },
    goSetSignPwd() {
      this.$router.push("/personal/users/safety/SetSignPwd");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.tipContent {
  height: 200px;
  width: 400px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: white;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 20px;
  .tipBox {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }
}
</style>
